
import { FiltersUsuario } from "../../stores/administracao/usuario"
import { ModuloComTelas } from "../../types/administracao/administracaoTypes"
import { AtributoSistema } from "../../types/administracao/atributoSistema"
import { GrupoAcessoResume } from "../../types/administracao/grupoAcesso"
import { Usuario } from "../../types/administracao/usuario"
import { ApiError, ApiResponse } from "../../types/global/apiTypes"
import { Pagination } from "../../types/global/Paginacao"
import { axiosInstance } from "../axiosInstance"
import handleAxiosError from "../handleAxiosError"
import { handleAxiosResponse } from "../handleAxiosResponse"


export const getTelas = async (): Promise<ApiResponse<ModuloComTelas[]>> => {
  try {
    const response = await axiosInstance().get<ModuloComTelas[] | ApiError>(`/administracao/telas-usuario`);
    return handleAxiosResponse<ModuloComTelas[]>(response);
  } catch (error) {
    return handleAxiosError(error);
  }
}

export const getUsuario = async (filters: FiltersUsuario): Promise<ApiResponse<Pagination<Usuario>>> => {
  try {
    const response = await axiosInstance().post<Pagination<Usuario> | ApiError>(`/administracao/filter-usuario`, filters);
    return handleAxiosResponse<Pagination<Usuario>>(response);
  } catch (error) {
    return handleAxiosError(error);
  }
}

export const getUsuarioById = async (id: number): Promise<ApiResponse<Usuario>> => {
  try {
    const response = await axiosInstance().get<Usuario | ApiError>(`/usuario/${id}`);
    return handleAxiosResponse<Usuario>(response);
  } catch (error) {
    return handleAxiosError(error);
  }
}

export const updateUsuario = async (usuario: Usuario): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().post<null | ApiError>(`/usuario/update-usuario`, usuario);
    return handleAxiosResponse<null>(response);
  } catch (error) {
    return handleAxiosError(error);
  }
}

export const createUsuario = async (usuario: Usuario): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().post<null | ApiError>(`/usuario/create-usuario`, usuario);
    return handleAxiosResponse<null>(response);
  } catch (error) {
    return handleAxiosError(error);
  }
}

export const deleteUsuario = async (id: number): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().delete<null | ApiError>(`/usuario/delete-usuario/${id}`);
    return handleAxiosResponse<null>(response);
  } catch (error) {
    return handleAxiosError(error);
  }
}

export const getGrupoAcessoResume = async (): Promise<ApiResponse<GrupoAcessoResume[]>> => {
  try {
    const response = await axiosInstance().get<GrupoAcessoResume[] | ApiError>(`/administracao/grupo-resume`);
    return handleAxiosResponse<GrupoAcessoResume[]>(response);
  } catch (error) {
    return handleAxiosError(error);
  }
}

export const getAtributoSistema = async (): Promise<ApiResponse<AtributoSistema>> => {
  try {
    const response = await axiosInstance().get<AtributoSistema | ApiError>(`/administracao/atributo-sistema`);
    return handleAxiosResponse<AtributoSistema>(response);
  } catch (error) {
    return handleAxiosError(error);
  }
}